import Vue  from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuItems: [
      { title: 'Kendeda EUI Visualizer', to: '/', tooltip: 'Detailed Breakdown of the Kendeda Building Energy Usage'},
    ],
    // All the BUD data grabber variables here
    KBEUI: {
      unit: 'SI',
    },
  },
  mutations: {
    updateKBEUI_unit(state, unit){
      state.KBEUI.unit = unit
    },
  },
})
